import { string, object } from 'yup';

export const newsletterValidationSchema = object({
  email: string().trim().email('Email must be valid').required('Please enter a valid email address'),
});
